import { render } from "./ButtonGreenPrimary.vue?vue&type=template&id=6200f7c0"
import script from "./ButtonGreenPrimary.vue?vue&type=script&lang=js"
export * from "./ButtonGreenPrimary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__